
<template>
    <svg width="24" height="24" viewBox="0 0 24 24" stroke="#3E4755" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 17L15 12L10 7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
<script>
export default {
    name: "ArrowRightIcon"
}
</script>
